"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormProps = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _reactFinalForm = require("react-final-form");

var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));

var _FormDatePicker = _interopRequireDefault(require("./FormDatePicker/FormDatePicker"));

var _FormTimePicker = _interopRequireDefault(require("./FormTimePicker/FormTimePicker"));

var _FormFileField = _interopRequireDefault(require("./FormFileField/FormFileField"));

var _FormSelectField = _interopRequireDefault(require("./FormSelectField/FormSelectField"));

var _FormTextField = _interopRequireDefault(require("./FormTextField/FormTextField"));

var _FormRadioGroupField = _interopRequireDefault(require("./FormRadioGroupField/FormRadioGroupField"));

var _FormDateTimePicker = _interopRequireDefault(require("./FormDateTimePicker/FormDateTimePicker"));

var _FormCheckbox = _interopRequireDefault(require("./FormCheckbox/FormCheckbox"));

var _FormTextFieldWithCounter = _interopRequireDefault(require("./FormTextFieldWithCounter/FormTextFieldWithCounter"));

var _FormAutoCompleteAdvanced = _interopRequireDefault(require("./FormAutoCompleteAdvanced/FormAutoCompleteAdvanced"));

var _UrlField = require("./UrlField");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "readOnly", "disabled", "initialValues"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var FormPropsContext = /*#__PURE__*/(0, _react.createContext)({});

var useFormProps = function useFormProps() {
  return (0, _react.useContext)(FormPropsContext);
};

exports.useFormProps = useFormProps;

var Form = function Form(props) {
  var children = props.children,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$initialValues = props.initialValues,
      initialValues = _props$initialValues === void 0 ? {} : _props$initialValues,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FormPropsContext.Provider, {
    value: {
      disabled: disabled,
      readOnly: readOnly
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Form, _objectSpread(_objectSpread({
      initialValues: initialValues
    }, rest), {}, {
      mutators: _objectSpread({}, _finalFormArrays.default),
      children: children
    }))
  });
};

Form.DatePicker = _FormDatePicker.default;
Form.TimePicker = _FormTimePicker.default;
Form.FileField = _FormFileField.default;
Form.SelectField = _FormSelectField.default;
Form.TextField = _FormTextField.default;
Form.RadioGroupField = _FormRadioGroupField.default;
Form.UrlField = _UrlField.UrlField;
Form.Field = _reactFinalForm.Field;
Form.DateTimePicker = _FormDateTimePicker.default;
Form.Checkbox = _FormCheckbox.default;
Form.TextFieldWithCounter = _FormTextFieldWithCounter.default;
Form.AutoCompleteAdvanced = _FormAutoCompleteAdvanced.default;
var _default = Form;
exports.default = _default;